import React from 'react';
import { useIntl } from 'react-intl';

import ActionButton from 'components/widgets/ActionButton/ActionButton';
import { ActionButtonTypesEnum } from 'interface';

function RetryErrorButton({
  isPending,
  isDisabled,
  retryDefaultMessage,
  retryTranslationId,
  checkConnectionTimer,
  handleRetry,
}: {
  isPending: boolean;
  isDisabled: boolean;
  retryDefaultMessage: string | undefined;
  retryTranslationId: string | undefined;
  checkConnectionTimer: number | undefined;
  handleRetry: () => Promise<void>;
}) {
  const intl = useIntl();

  if (checkConnectionTimer !== undefined || !retryTranslationId) {
    return null;
  }

  const buttonLabel = intl.formatMessage({ defaultMessage: retryDefaultMessage, id: retryTranslationId });

  return (
    <ActionButton
      title={buttonLabel}
      isPending={isPending}
      onClick={handleRetry}
      type={ActionButtonTypesEnum.primary}
      disabled={isDisabled}
    />
  );
}

export default RetryErrorButton;
